import React, { useEffect, useState } from 'react';
import { css } from '@emotion/react';

const origin_url = typeof window !== 'undefined' ? window.location.origin : '';
export const env = origin_url.includes('store.zigzag.kr')
  ? 'production'
  : (origin_url.match(/store.(.*)\.zigzag/)?.[1] ?? 'local');

const Stage = () => {
  const [stage, setStage] = useState<string>('');

  useEffect(() => {
    setStage(env);
  }, []);

  return (
    <div
      css={css`
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 10000;
        display: ${!!stage && stage !== 'production' ? 'block' : 'none'};
        font-size: 13px;
        opacity: 0.5;
        color: green;

        .stage {
          margin: 0 3px;
          font-weight: bold;
        }
      `}
    >
      <span className='stage'>{stage?.toUpperCase()}</span>
    </div>
  );
};
export default Stage;
